import { render, staticRenderFns } from "./EcosystemModal.vue?vue&type=template&id=12ef7b99&"
import script from "./EcosystemModal.vue?vue&type=script&lang=js&"
export * from "./EcosystemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ef7b99')) {
      api.createRecord('12ef7b99', component.options)
    } else {
      api.reload('12ef7b99', component.options)
    }
    module.hot.accept("./EcosystemModal.vue?vue&type=template&id=12ef7b99&", function () {
      api.rerender('12ef7b99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/vuln-sources/EcosystemModal.vue"
export default component.exports